module.exports = __webpack_public_path__ + "static/media/a17.8db9700d.jpg";